import { ButtonPosition, ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
import cloneDeep from 'lodash/cloneDeep';
import isPlainObject from 'lodash/isPlainObject';
import { calculateTextExprValue, getArrayTableCurrentRowByField2, isArrayNotEmpty, } from '@/common/util/util';
import { handleRequestParams } from '@/common/util/request';
import { __arrayTableCurrentRow__ } from '@/common/util/expr-const';
export const config = {
    value: 'setFormValue',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, urlParamsDataSource, state, _context, field, position, arrayBaseFieldIndex, parentComponentName, } = config || {};
        const { options } = buttonConfig || {};
        const { formValues, _bindForm, handleType, allFormValues } = options || {};
        if (_bindForm) {
            const formNode = _context?.$(_bindForm);
            const formInstance = formNode?.getFormInstance?.();
            if (formInstance) {
                const oldFormValue = cloneDeep(formInstance?.values);
                if (handleType === 'clearFormValue') {
                    formInstance.setValues?.({}, 'overwrite');
                }
                else if (handleType === 'setAllFormValue') {
                    const newFormValue = calculateTextExprValue(allFormValues, {
                        urlParamsDataSource,
                        recordDataSource: oldFormValue,
                        state,
                    });
                    if (isPlainObject(newFormValue)) {
                        formInstance.setValues?.(newFormValue, 'overwrite');
                    }
                }
                else {
                    let newFormValue;
                    let extraParamList = [{}];
                    if ([ButtonPosition.formItemEvent].includes(position) &&
                        ['CnArrayTable'].includes(parentComponentName)) {
                        extraParamList = [
                            {
                                [__arrayTableCurrentRow__]: getArrayTableCurrentRowByField2(field) || {},
                            },
                        ];
                    }
                    if (Array.isArray(formValues)) {
                        if (formValues.length > 0) {
                            const arrayTableValues = [];
                            const notArrayTableValues = [];
                            formValues.forEach((item) => {
                                if (item?.label?.includes(__arrayTableCurrentRow__)) {
                                    arrayTableValues.push(item);
                                }
                                else {
                                    notArrayTableValues.push(item);
                                }
                            });
                            const temp = handleRequestParams(notArrayTableValues, {
                                urlParamsDataSource,
                                recordDataSource: oldFormValue || {},
                                state,
                                extraParamList,
                            });
                            if (isArrayNotEmpty(arrayTableValues)) {
                                let fieldIndex;
                                if (position === ButtonPosition.arraySubAreaCardOperate) {
                                    fieldIndex = arrayBaseFieldIndex;
                                }
                                else if (field) {
                                    fieldIndex = field?.path?.segments?.[1];
                                }
                                if (typeof fieldIndex === 'number') {
                                    const tempFormValue = { ...oldFormValue, ...temp };
                                    arrayTableValues.forEach((aitem) => {
                                        const { label } = aitem || {};
                                        const arr = label?.split?.(`.${__arrayTableCurrentRow__}.`);
                                        if (arr.length === 2) {
                                            const fieldName = arr[0];
                                            const arrayTableFieldName = arr[1];
                                            const temp2 = handleRequestParams([aitem], {
                                                urlParamsDataSource,
                                                recordDataSource: tempFormValue,
                                                state,
                                                extraParamList,
                                            });
                                            if (fieldName &&
                                                arrayTableFieldName &&
                                                tempFormValue[fieldName]?.[fieldIndex]) {
                                                tempFormValue[fieldName][fieldIndex][arrayTableFieldName] = temp2[label];
                                                temp[fieldName] = tempFormValue[fieldName];
                                            }
                                        }
                                    });
                                }
                            }
                            if (isPlainObject(temp)) {
                                newFormValue = temp;
                            }
                        }
                    }
                    formInstance.setValues?.(newFormValue, handleType === 'setFormFieldValueShallowMerge'
                        ? 'shallowMerge'
                        : 'merge');
                }
            }
        }
        return Promise.resolve();
    },
};
